import { CoreBancarioPage } from './CoreBancarioPage';
export default CoreBancarioPage;
